<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<form name="digitizeLayers" cdkTrapFocus>
    <div>
        <h1 mat-dialog-title>Digitize a Point</h1>
        <div>
            <mat-select [(ngModel)]="selectedLayer"
                        placeholder="Choose Layer:"
                        #auto="ngModel"
                        name="csDigitizeLayer"
                        required="true">
                <mat-option *ngFor="let layerDefinition of data.layers"
                            [value]="layerDefinition.layer"
                            [disabled]="!(canCreatePoint$(layerDefinition.layer) | async)"
                            fxLayout="row" fxLayoutAlign="space-between center">
                    <span class="digi-option-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="layer-name">{{ layerDefinition.displayName }}</span>
                        <span class="selection-help">{{getSelectionHelpText(layerDefinition)}}</span>
                    </span>
                </mat-option>
            </mat-select>
        </div>
    </div>
    <div>
        <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
            <button mat-button type="submit"
                    [disabled]="auto.value=='' || !auto.valid"
                    (click)="chooseLayer()">Select</button>
            <button mat-button (click)="cancel()">Cancel</button>
        </div>
    </div>
</form>
